import React from 'react';
import { Typography, Grid, makeStyles, Button, Theme } from '@material-ui/core'
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { User, UserRole } from '../../domain/domain';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: 100,
    },
    nav: {
        marginTop: 50
    },
    button: {
        textTransform: 'none',
        color: '#186ea8',
        fontSize: 24,
        fontWeight: 300,
        // Hover styles for enabled buttons
        '&:not([aria-disabled="true"]):hover': {
            backgroundColor: 'inherit',
            textDecoration: 'underline',
        },
        // Styles for ARIA-disabled buttons
        '&[aria-disabled="true"]': {
            color: '#949494',
            cursor: 'not-allowed',
        },
    }
}));

const Landing: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();

    let currentUser: User | undefined = useSelector((app: ApplicationState) => app.user.currentUser);
    const isNonPublicationsTeam = currentUser?.userRole === UserRole.NON_PUBLICATIONS_TEAM;
    const defaultDisabledButton: boolean = true;
    return (
        <Grid container direction='column' alignContent='center' className={`${classes.root} flex-gap-5`} alignItems='center'>
            <Grid item>
                <Typography variant='h1'>Welcome to XDOME</Typography>
            </Grid>
            <Grid item className={classes.nav}>
                <Grid container direction='column' alignItems='center'>
                    <Grid item>
                        <Button size="large" className={classes.button} onClick={() => { history.push("/component") }}>Provision Management</Button>
                    </Grid>
                    <Grid item>
                        <Button
                            aria-disabled={isNonPublicationsTeam}
                            size="large"
                            className={classes.button}
                            onClick={() => {
                                if (!isNonPublicationsTeam) {
                                    history.push("/red-book");
                                }
                            }}
                        >
                            Red Book Page to Print/View/Merge a Bill
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            aria-disabled={isNonPublicationsTeam}
                            size="large"
                            className={classes.button}
                            onClick={() => {
                                if (!isNonPublicationsTeam) {
                                    history.push("/status");
                                }
                            }}
                        >
                            Title Status
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            aria-disabled={defaultDisabledButton}
                            size="large"
                            className={classes.button}
                            onClick={() => { if(!defaultDisabledButton){ history.push("/scheduled")} }}
                        >
                            Statute Components scheduled for a future repeal
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Landing;
